const getNumberArrayFromSearchParam = (param: null | undefined | string | (string | null)[]) => {
  if (param === null || param === undefined) return undefined;

  if (typeof param === "string") {
    return param
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean)
      .map((item) => +item);
  }

  return (param.filter((item) => !!item) as string[]).map((item) => +item);
};

export default getNumberArrayFromSearchParam;
